module.exports = __webpack_public_path__ + "static/img/花卉传感器信息管理平台.67e78af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert/花卉传感器信息管理平台.jpg
// module id = v7lw
// module chunks = 15